export default function initFaq() {
    const searchInput = document.getElementById('faq-search');
    const filterBtns = document.querySelectorAll('.c-faq__filter-btn');
    const faqItems = document.querySelectorAll('.c-faq__list details');
    const totalCounter = document.getElementById('faq-total');

    const filterCountDisplay = document.querySelector('.js-filter-count');
    const mobileTrigger = document.querySelector('.c-faq__mobile-filter-trigger');
    const sidebar = document.querySelector('.c-faq__sidebar');
    const applyBtn = document.getElementById('apply-filters');
    const clearBtn = document.getElementById('clear-filters');
    const closeBtn = document.querySelector('.c-faq__sidebar-close');

    function updateFilterTriggerCount() {
        if (!filterCountDisplay) return;
        const activeFilters = document.querySelectorAll('.c-faq__filter-btn.active').length;
        filterCountDisplay.innerText = activeFilters;
    } 
    const closeSidebar = () => {
        sidebar.classList.remove('is-active');
        document.body.style.overflow = '';
    };

    mobileTrigger?.addEventListener('click', (e) => {
        e.preventDefault(); 
        sidebar.classList.add('is-active');
        document.body.style.overflow = 'hidden';
    });

    closeBtn?.addEventListener('click', closeSidebar);

    applyBtn?.addEventListener('click', () => {
        filterLogic();
        closeSidebar();
    });

    clearBtn?.addEventListener('click', () => {
        searchInput.value = '';
        filterBtns.forEach(b => b.classList.remove('active'));
        filterLogic();
        closeSidebar();
    });
    if (!faqItems.length || !totalCounter) return;

    function updateCounter(count) {
        const text = count === 1 ? 'pergunta' : 'perguntas';
        totalCounter.innerText = `${count} ${text}`;
    }

    function filterLogic() {
        const searchTerm = searchInput.value.toLowerCase().trim();
        const activeBtn = document.querySelector('.c-faq__filter-btn.active');

        const activeFilter = activeBtn ? activeBtn.dataset.filter : 'all';

        let visibleCount = 0;

        faqItems.forEach(item => {
            const questionText = item.querySelector('summary').innerText.toLowerCase();
            const category = item.getAttribute('data-category') || '';

            const matchesSearch = searchTerm === '' || questionText.includes(searchTerm);
            const matchesCategory = activeFilter === 'all' || category === activeFilter;

            if (matchesSearch && matchesCategory) {
                item.style.display = 'block';
                visibleCount++;
            } else {
                item.style.display = 'none';
                item.removeAttribute('open');
            }
        });

        updateCounter(visibleCount);
        updateFilterTriggerCount();
    }

    searchInput?.addEventListener('input', filterLogic);

    filterBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            filterBtns.forEach(b => b.classList.remove('active'));
            btn.classList.add('active');
        });
    });

    applyBtn?.addEventListener('click', () => {
        filterLogic();
        if (window.innerWidth <= 768) {
            sidebar.classList.remove('is-active');
        }
    });

    clearBtn?.addEventListener('click', () => {
        searchInput.value = '';
        filterBtns.forEach(b => b.classList.remove('active'));


        filterLogic();

        if (window.innerWidth <= 768) {
            sidebar.classList.remove('is-active');
        }
    });
    mobileTrigger?.addEventListener('click', (e) => {
        e.preventDefault(); 
        sidebar.classList.add('is-active');
        document.body.style.overflow = 'hidden';
    });

    applyBtn?.addEventListener('click', () => {
        filterLogic();
        sidebar.classList.remove('is-active');
        document.body.style.overflow = '';
    });

    clearBtn?.addEventListener('click', () => {
        searchInput.value = '';
        filterBtns.forEach(b => b.classList.remove('active'));
        filterLogic();
        sidebar.classList.remove('is-active');
        document.body.style.overflow = '';
    });
    filterLogic();
}